<template>
  <div id="milestones" class="pos-rel" @click.stop.prevent>
    <div class="milestone-wrapper">
      <div class="align-hor center-ver pos-rel"
           style="display: flex;
    align-content: center;
    width: 100%;
    height: 40px;
    overflow-x: scroll;
    flex-direction: row;
    align-items: flex-end;"
        :class="[model.mile_stones.length >= 5 && windowWidth>511 ? 'start-hor':'center-hor']"
      >
        <div class="db-wrapper" v-for="(ms, i) in model.mile_stones" ref="milestones" :style="(i == (milestones.length - 1))?'margin-right:5px; padding-right:16px':''">
          <div>
            <div class="lined-bg align-ver center-hor" v-if="ms.is_checked">
              <div class="pos-rel align-hor center-ver center-hor" v-if="ms.won">
                <img class="w-17" src="@/assets/medal.svg" slot="reference"  @click.stop.prevent="emitMileStone(ms)" data-toggle="modal" data-target="#exampleModalCenter">
              </div>
              <div class="radius50 bg-light padding-4 align-hor center-ver center-hor wh10" :style="{background: bgTheme}" v-else>
                <div class="check-mark"></div>
              </div>
            </div>
            <div class="dotted-bg align-ver center-hor" v-else>
              <div class="pos-rel align-hor center-ver center-hor" v-if="ms.to_earn">
                <img class="w-20" :src="ms.icon" slot="reference"
                     @click.stop.prevent="emitMileStone(ms)" data-toggle="modal" data-target="#exampleModalCenter">

              </div>
              <div class="radius50 bg-light padding-4" style="border: 1px solid #6D6666" v-else>
                <div class="radius50 wh10" :style="{background: bgTheme}"></div>
              </div>
            </div>
            <div :class="(i == 0) ? 'text-left' : (i == (milestones.length - 1)) ? 'text-right' : ''" style="padding-top: 0.4rem; width: 100%"
                 :style="[ms.is_checked ?'font-weight: 900':'font-weight: 500']">{{ms.text}}</div>
          </div>

<!--          <div v-if="ms.show_popup"><mile-stone-popper :model="ms"></mile-stone-popper></div>-->

        </div>

      </div>

    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals";
  import Popper from '@/components/popper';
  import MilestoneDetailPopup from '@/components/milestone-detail-popup';
  import '../assets/vue-popper.css';


  export default {
    mixins: [globals],
    props: {
      model: Object
    },
    components: {
      'popper': Popper,
      'mile-stone-popper': MilestoneDetailPopup
    },
    data() {
      return {
        show_popup: false,
        windowWidth : window.screen.width,
      }
    },
    methods: {
      getOffset(el) {
        const rect = setTimeout(()=>{el.getBoundingClientRect()},1000);
        return {
          left: rect.left ,
          top: rect.bottom
        };
      },
      emitMileStone(ms){
        this.toggleMileStoneModal(true, ms)
        this.$emit('msData',ms)
      }
    },

    computed: {
      cssVars() {
        return {
          'transform':`translate3d(30px,-200px,0) !important;`,

        }
      }
    },
    created() {
      var offer = this.model;
      this.formatUserCheckins(offer);
      this.model.mile_stones = this.$store.state.user.mile_stones;
    },
    mounted() {

    }
  }
</script>
<style>
  .db-wrapper{
  }

  .milestone-wrapper {
    white-space: nowrap;
    background: #ffffff;
    left: 0;
    right: 0;
    //padding: 10px 0px 10px 50px;
    padding: 1.25rem;

  }
  .milestone-wrapper .check-mark {
    display: inline-block;
    transform: rotate(45deg);
    width: 2px;
    height: 6px;
    border-bottom: 2px solid #ffffff;
    border-right: 2px solid #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/milestone.vue